import { firestore } from '@utils/firebase'
import { ApiResponse } from '@Interfaces/Api/ResponsesInterface'
import { Skill } from '@Interfaces/Data/SkillInterface'
import { User } from '@Interfaces/Data/UserInterface'

export const getSkills = async (): Promise<ApiResponse<Skill[]>> => {
  try {
    const querySnapshot = await firestore.collection('skills').orderBy('lowercaseName', 'asc').get()

    const skills: Skill[] = querySnapshot.docs.map(
      (doc) =>
        ({
          id: doc.id,
          ...doc.data(),
        }) as Skill
    )

    return { success: true, data: skills }
  } catch (error: any) {
    return {
      success: false,
      error: error?.message || 'Failed to fetch skills',
      data: undefined,
    }
  }
}

export const getOurSkills = (currentUser: User | null, allSkills: Skill[]): Skill[] => {
  if (
    !currentUser?.skills ||
    !Array.isArray(currentUser.skills) ||
    currentUser.skills.length === 0
  ) {
    return []
  }

  if (!allSkills || !Array.isArray(allSkills)) {
    return []
  }

  return allSkills.filter((skill) => skill.id && currentUser.skills?.includes(skill.id))
}
